export default class Resource {
    constructor(resource) {
        this.baseUrl = resource.baseUrl
        this.name = resource.name
        this.dates = resource.dates
      }

    handleError(message) {
        console.error(message);
        alert('There was a problem: '+message+'. Please notify the development team.');
    }

    objectToQueryString(obj) {
        var params = [];
        for (var key in obj) {
            params.push(key+'='+obj[key]);
        }
        return '?'+params.join('&');
    }

    makeRequest(method, url, data) {
        if(!url){
            throw 'No url';
        }

        method = (method) ? method : 'GET';

        var request = {
            method: method,
            url: url,
        }

        if (data) {
            request.data = data;
        }

        return window.axios(request);
    }

    all(params) {
        var url = this.baseUrl+this.objectToQueryString(params);
        return this.makeRequest('get', url)
                .then(function (response) {
                    var data = response.data.map(function (item) {
                        return this.transformDates(item);
                    }.bind(this));

                    var retVal = {
                        data: data,
                        status: response.status,
                        headers: response.headers,
                        request: response.request,
                        statusText: response.statusText,
                        config: response.config
                    };
                    return retVal;
                }.bind(this))
                .catch(function(error){
                    handleError('Unable to retrieve '+this.name)
                    return error;
                }.bind(this));
    }

    find(id, params) {
        var url = this.baseUrl+'/'+id+this.objectToQueryString(params);
        return this.makeRequest('get', url).then(function (response) {
            response.data = this.transformDates(response.data);
            return response
        }.bind(this));
    }

    save(data) {
        for (var key in data) {
            if(data[key] && data[key]._isAMomentObject){
                data[key] = data[key].format('YYYY-MM-DD HH:mm:ss');
            }else if( this.dates.indexOf(key) > -1){
                data[key] = moment(data[key]).format('YYYY-MM-DD HH:mm:ss');
            }
        }

        if (data.id) {
            return this.update(data);
        }else{
            return this.store(data);
        }
    }

    store(data) {
        return this.makeRequest('post', this.baseUrl, data)
            .then(function (response) {
                response.data = this.transformDates(response.data);
                return response;
            });
    }

    update(data) {
        return this.makeRequest('put', this.baseUrl+'/'+data.id, data);
    }

    destroy(id) {
        return this.makeRequest('delete', this.baseUrl+'/'+id);
    }

    transformDates(obj) {
        var data = {};
        for (var key in obj) {
            if( this.dates.indexOf(key) > -1){
                data[key] = moment(obj[key]);
            }else{
                data[key] = obj[key]
            }
        }
        return data;
    }

};